import { useContext } from 'react';
import { CollapseDrawerContext } from '@utility/contexts/CollapseDrawerContext';

// ----------------------------------------------------------------------

const useCollapseDrawer = () => useContext(CollapseDrawerContext);

export default useCollapseDrawer;
